import { useMemo } from "react";
import { useRxNavDisplayNames, useRxNavDrugQuery, useRxNavNdcCodesQueries, useRxNavNormCodeQuery } from "./rx-nav";

export interface UseMedicationLookupArgs {
  selectedDisplayName?: string;
  selectedSpecificDrugName?: string;
}

export const useMedicationLookup = ({ selectedDisplayName, selectedSpecificDrugName }: UseMedicationLookupArgs) => {
  const displayNamesQuery = useRxNavDisplayNames({
    enabled: !selectedDisplayName,
    select: (data) => data.displayTermsList.term.filter((term) => !/^[(\d.]/.test(term)),
  });

  const drugQuery = useRxNavDrugQuery({
    request: { name: selectedDisplayName ?? "" },
    enabled: !!selectedDisplayName,
    select: (data) => ({
      name: data.drugGroup.name,
      concepts: data.drugGroup.conceptGroup.flatMap((group) => group.conceptProperties ?? []),
    }),
  });

  const rxNormCodeQuery = useRxNavNormCodeQuery({
    request: {
      name: selectedSpecificDrugName ?? "",
    },
    enabled: !!selectedSpecificDrugName,
    select: (data) => data.idGroup.rxnormId,
  });

  const ndcCodesQueries = useRxNavNdcCodesQueries({
    request: {
      rxNormCodes: rxNormCodeQuery.data ?? [],
    },
    enabled: !!rxNormCodeQuery.data?.length,
    select: (data) => data.ndcGroup.ndcList.ndc,
  });
  const ndcCodes = useMemo(() => ndcCodesQueries.flatMap((query) => query.data ?? []), [ndcCodesQueries]);

  return {
    allDisplayNames: displayNamesQuery.data ?? [],
    specificDrugOptions: drugQuery.data?.concepts ?? [],
    rxNormCode: rxNormCodeQuery.data ?? [],
    ndcCodes,
  };
};
